<template>
  <v-app-bar app height="100">
    <v-app-bar-nav-icon
      @click="drawer()"
      class="primary--text"
    ></v-app-bar-nav-icon>
    <v-container class="py-0 fill-height" fluid>
      <div
        class="mr-3"
        v-if="
          $vuetify.breakpoint.name == 'lg' ||
          $vuetify.breakpoint.name == 'xl' ||
          $vuetify.breakpoint.name == 'md'
        "
      >
        <v-img src="@/assets/gambar/logo-new.png" max-width="200"></v-img>
      </div>

      <div class="mr-3" v-else>
        <v-img src="@/assets/gambar/logo-new.png" max-width="150"></v-img>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import { version } from "../../package";

import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";

import Dmenu from "@/store/menu";

export default {
  data: () => ({
    appVersion: version,

    token: Cookie.get("token"),
    session: "",

    nipBaru: "",
    namaPegawai: "",
    foto: "",

    READ_ASN_ME: false,
  }),

  async mounted() {
    this.session = await JSON.parse(Cookie.dec(Cookie.get("myCookie")));
    this.cek();
    this.getData();
  },

  methods: {
    drawer() {
      Dmenu.commit("toggle", !Dmenu.state.drawer);
    },

    getData() {
      const url =
        process.env.VUE_APP_ASN + "datautama/nip/" + this.session.nipBaru;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.nipBaru = response.data.mapData.DataUtama.nipBaru;
          this.namaPegawai = response.data.mapData.DataUtama.nama;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    logout() {
      Cookie.delete();
      localStorage.clear();
      window.location.href = process.env.VUE_APP_LOGIN;
    },

    edit() {
      window.open("https://account.idasn.pohuwatokab.go.id", "_blank");
    },

    cek() {
      this.READ_ASN_ME = this.session.authorities.includes("READ_ASN_ME");
    },
  },
};
</script>
